export const PageDataState = {
    Searchs: {
        type_a_student_id: {
            type: 'text',
            id: 'type_a_student_id',
            label: 'นักศึกษา',
            value: '',
            placeholder: 'นักศึกษา'
        }
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primary',
                required: false
            },
            error: { status: null, msg: '' }
        },
        type_a_student_id: {
            type: 'text',
            id: 'type_a_student_id',
            label: 'รหัสนักศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        education_type_id: {
            type: 'select',
            id: 'education_type_id',
            label: 'ประเภทสถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        education_level_id: {
            type: 'select',
            id: 'education_level_id',
            label: 'ระดับการศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },        
        faculty_id: {
            type: 'select',
            id: 'faculty_id',
            label: 'คณะ',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        department_id: {
            type: 'select',
            id: 'department_id',
            label: 'สาขาวิชา',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        department_work_id: {
            type: 'select',
            id: 'department_work_id',
            label: 'สาขางาน',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
    },
    InputGroup: {}
}